import { FlowBox, HorizBox, Pad, VertBox } from 'component/basics';
import { Tag } from 'component/button';
import { Byline, FaceButton, FacePile, LetterFace, ProfilePhoto } from 'component/people';
import { useState } from 'react';
import { CLICK, component, DemoSection, demoFile, SpacedArray, story, variant } from 'system/demo';
import { WithConfig } from 'util/instance';

demoFile('component/people', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=1102-4732&t=MC9nppcf9h2iJDKP-1',
});

function ProfilePhotoDemo() {
    return (
        <VertBox gap={16}>
            <SpacedArray horiz pad={8}>
                <ProfilePhoto userId='a' />
                <ProfilePhoto type='small' userId='b' />
                <ProfilePhoto type='tiny' userId='c' />
                <ProfilePhoto check={true} userId='d' />
                <ProfilePhoto check type='small' userId='e' />
                <ProfilePhoto check type='tiny' userId='f' />
            </SpacedArray>
            <SpacedArray horiz pad={8}>
                <ProfilePhoto userId='x' />
                <ProfilePhoto type='small' userId='y' />
                <ProfilePhoto type='tiny' userId='z' />
            </SpacedArray>
        </VertBox>
    );
}

component('ProfilePhoto', ProfilePhotoDemo);

function FacePileDemo() {
    return (
        <HorizBox gap={16}>
            <FacePile type='small' userIdList={['a', 'b', 'c', 'z']} />
            <FacePile type='tiny' userIdList={['x', 'd', 'e', 'f', 'g', 'h', 'i', 'j']} />
        </HorizBox>
    );
}

component('FacePile', FacePileDemo);

function BylineDemo() {
    return (
        <VertBox gap={16}>
            <DemoSection mini text='Large'>
                <Byline time={Date.now()} type='large' userId={'a'} />
                <Byline edited={true} time={Date.now() - 1000 * 60 * 10} type='large' userId={'b'} />
                <Byline edited={true} time={Date.now() - 1000 * 60 * 60 * 10} type='large' userId={'y'} />
            </DemoSection>
            <DemoSection mini text='Small'>
                <Byline time={Date.now()} type='small' userId={'c'} />
                <Byline showMetadata={false} type='small' userId={'d'} />
                <Byline edited={true} time={Date.now()} type='small' userId={'e'} />
                <Byline time={Date.now()} type='small' userId='x' />
                <Byline time={Date.now()} type='small' userId='z' />
            </DemoSection>
            <DemoSection mini text='Tiny'>
                <Byline time={Date.now()} type='tiny' userId='x' />
                <Byline time={Date.now()} type='tiny' userId='z' />
            </DemoSection>
            <DemoSection mini text='Anonymous'>
                <Byline name='Anonymous User' time={Date.now()} type='large' />
                <Byline edited name='Anonymous User' time={Date.now() - 1000 * 60 * 10} type='large' />
                <Byline name='Anonymous User' time={Date.now()} type='small' />
                <Byline name='Anonymous User' type='small' />
            </DemoSection>
            <DemoSection text='With Tags'>
                <WithConfig config={{ bylineTags: [() => <Tag text='Awesome Person' type='tiny' />] }}>
                    <Byline type='large' userId='a' />
                    <Pad />
                    <Byline edited={true} time={Date.now()} type='large' userId='b' />
                </WithConfig>
            </DemoSection>
        </VertBox>
    );
}

component('Byline', BylineDemo);

function LetterFaceDemo() {
    return (
        <FlowBox columnGap={8} rowGap={8}>
            <LetterFace hue={183} name='dave' type='huge' />
            <LetterFace hue={0} name='bill' type='huge' />
            <LetterFace hue={45} name='jane' type='large' />
            <LetterFace hue={90} name='sarah' type='large' />
            <LetterFace hue={135} name='ella' type='small' />
            <LetterFace hue={180} name='carl' type='small' />
            <LetterFace hue={225} name='mica' type='tiny' />
            <LetterFace hue={300} name='betty' type='tiny' />
        </FlowBox>
    );
}

component('LetterFace', LetterFaceDemo);

function FaceButtonDemo() {
    const [selected, setSelected] = useState(false);
    return (
        <HorizBox gap={16}>
            <FaceButton onPress={() => setSelected(!selected)} selected={selected} testID='face'>
                <LetterFace hue={183} name='dave' type='huge' />
            </FaceButton>
            <FaceButton onPress={() => setSelected(!selected)} selected={!selected}>
                <ProfilePhoto type='huge' userId='a' />
            </FaceButton>
        </HorizBox>
    );
}

component('FaceButton', FaceButtonDemo, {}, [story('Select', [CLICK('face')])]);
